import { SITE_ORIGIN } from '../../constants/categorySeoSlugs';

/** 카카오톡·OG 공유 썸네일 (public/session-result-og.png) */
export const SESSION_RESULT_OG_IMAGE = `${SITE_ORIGIN}/session-result-og.png`;
export const SESSION_RESULT_OG_IMAGE_WIDTH = 560;
export const SESSION_RESULT_OG_IMAGE_HEIGHT = 294;

export const SESSION_RESULT_SITE_NAME = '사운드필';
